import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { ICountry } from 'models/country';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';


interface Props {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const AddCity: React.FC<Props> = ({ open, loading, onClose, onSubmit, onChanges }) => {
  let basicFields: IFormField[] = [
    {
      name: 'name',
      label: t('T_name'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_name'),
      internalLabel: true,
      required: true
    },
    {
      name: 'nameAr',
      label: `${t('T_name')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      placeholder: `${t('T_enter_name')} ${t('T_in_arabic')}`,
      internalLabel: true
    },
    {
      name: 'isPretest',
      label: `${t('T_is_pretest')}`,
      type: InputTypes.CHECKBOX,
      internalLabel: true,
      required: false
    },
    {
      name: 'isPosttest',
      label: `${t('T_is_posttest')}`,
      type: InputTypes.CHECKBOX,
      internalLabel: true,
      required: false
    },
    {
      name: 'isCertifiedtest',
      label: `${t('T_is_certifiedtest')}`,
      type: InputTypes.CHECKBOX,
      internalLabel: true,
      required: false
    },
    {
      name: 'isPsychometrictest',
      label: `${t('T_is_psychometrictest')}`,
      type: InputTypes.CHECKBOX,
      internalLabel: true,
      required: false
    },
  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_add_vendor_assessment_type')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_add')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default AddCity;
